import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-xs w-3 h-3 flex items-center justify-center text-foreground-300" />
          )}
          {item.to ? (
            <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="whitespace-nowrap text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}